<div id="imageInfoDetailBox">
  <div class="column-list" style="padding:8px;">
    <label class="list-input-title">使用開始受注コード</label>
    <div class="list-input-content">
      <app-order-code-text-input id="txi_StartOrderCode" [subid]="'txi_StartOrderCode'"
        [forcedEnabledMode]="'true'" #txi_StartOrderCode
        [disabled]="txiStartOrderCodeDisabled" [(ngModel)]="startOrderCode"
        (ngModelChange)="parentModel.kymw1600Component.bindStartOrderCodeTextInputSelectedOrderCode(txi_StartOrderCode.selectedOrderCode)" [tabindex]="0" >
      </app-order-code-text-input>
    </div>

    <label class="list-input-title">使用終了受注コード</label>
    <div class="list-input-content element-column">
      <app-order-code-text-input id="txi_EndOrderCode1" [subid]="'txi_EndOrderCode1'"
        [forcedEnabledMode]="'true'" #txi_EndOrderCode1
        [disabled]="txiEndOrderCode1Disabled" [(ngModel)]="endOrderCode" [editable]="!txitxiEndOrderCode1ReadOnly" [tabindex]="0">
      </app-order-code-text-input>
      <select id="cmb_EndOrderCode2" [(ngModel)]="endOrderCode2"
        forcedEnabledMode="true" #cmb_EndOrderCode2 [disabled]="cmbEndOrderCode2Disabled"
        (change)="parentModel.kymw1600Component.bindEndOrderCodeComboBox(endOrderCode2)" [tabindex]="0" >
        <ng-template ngFor let-item [ngForOf]="this.endOrderCode2_dataProvider">
          <option value="{{item.data}}">{{item.label}}</option>
        </ng-template>
      </select>
    </div>

    <label class="list-input-title">画像名</label>
    <div class="list-input-content">
      <input type="text" id="lbl_ImageName" #lbl_ImageName value="{{ this.imageName }}" readonly>
    </div>

    <label class="list-input-title">画像ファイル名</label>
    <div class="list-input-content">
      <input type="text" id="lbl_ImageFileName" #lbl_ImageFileName value="{{ this.imageFileName }}" readonly>
    </div>

    <label class="list-input-title">所属</label>
    <div class="list-input-content">
      <input type="text" id="lbl_ImageBelongName" #lbl_ImageBelongName value="{{ this.imageBelongName }}" readonly>
    </div>

    <label class="list-input-title">画像種類</label>
    <div class="list-input-content">
      <input type="text" id="lbl_ImageKindName" #lbl_ImageKindName value="{{ this.imageKindName }}" readonly>
    </div>

    <label class="list-input-title">画像種別</label>
    <div class="list-input-content">
      <input type="text" id="lbl_ImageTypeName" #lbl_ImageTypeName value="{{ this.imageTypeName }}" readonly>
    </div>

    <label class="list-input-title">調理指示</label>
    <div class="list-input-content">
      <app-code-combo-box id="cmb_ProcessInstruct" [subid]="'cmb_ProcessInstruct'" [codeDiv]="'ct368'"
        [forcedEnabledMode]="'true'" [tabindex]="0" [labelField]="'codeValueName'" #cmb_ProcessInstruct
        [(ngModel)]="processInstruct" [disabled]="cmbProcessInstructDisabled">
        </app-code-combo-box>
    </div>

    <label class="list-input-title">備考</label>
    <div class="list-input-content">
      <app-text-area [restrict]="'[ -￮]'"
        [fullOnly]="true" id="txi_Remarks" #txi_Remarks [subid]="'txi_Remarks'" [maxChars]="128" [tabindex]="0" [forcedEnabledMode]="'true'"
        [verticalScrollPolicy]="'on'" [horizontalScrollPolicy]="'off'"  [displayCountField]="false"
        [(ngModel)]="remarks" [disabled]="txiRemarksDisabled">
      </app-text-area>
    </div>

    <label class="list-input-title">調理例掲載区分</label>
    <div class="list-input-content">
      <label>
        <input type="checkbox" id="ckb_CookingExPublish" [(ngModel)]="cookingExPublish"
          forcedEnabledMode="true" [tabindex]="0" #ckb_CookingExPublish
          [(ngModel)]="cookingExPublish" [disabled]="ckbCookingExPublishDisabled">掲載あり
      </label>
    </div>

    <label class="list-input-title">優先度</label>
    <div class="list-input-content">
      <app-text-input [halfOnly]="true" id="txi_Priority" #txi_Priority [subid]="'txi_Priority'"
        [forcedEnabledMode]="'true'" [restrict]="'[0-9]'" [maxChars]="2" [displayCountField]="false"
        [(ngModel)]="priority" [disabled]="txiPriorityDisabled" [tabindex]="0" style="width:2rem;">
      </app-text-input>
    </div>

    <label class="list-input-title">Ｐコード</label>
    <div class="list-input-content">
      <input type="text" class="pcode" id="lbl_Pcode" #lbl_Pcode value="{{ this.pcode }}" readonly>
    </div>

    <label class="list-input-title">商品案内用商品名</label>
    <div class="list-input-content">
      <input type="text" class="guide-goods-name" id="lbl_GuideGoodsName" #lbl_GuideGoodsName value="{{ this.guideGoodsName }}" readonly>
    </div>

    <label class="list-input-title">商品案内用規格名</label>
    <div class="list-input-content">
      <input type="text" class="guide-standard-name" id="lbl_GuideStandardName" #lbl_GuideStandardName value="{{ this.guideStandardName }}" readonly>
    </div>

    <label class="list-input-title">料理分類</label>
    <div class="list-input-content">
      <app-code-combo-box id="cmb_CookingDiv" [subid]="'cmb_CookingDiv'" [codeDiv]="'ct369'" [forcedEnabledMode]="'true'"
        initFocusItem="{KYMW1600ViewHelper(ViewLocator.getInstance().getViewHelper('KYMW1600ViewHelper')).selfView.imageInfoList.btn_Search}"
        [labelField]="'codeValueName'" #cmb_CookingDiv [(ngModel)]="cookingDiv"
        [disabled]="cmbCookingDivDisabled" [tabindex]="0" ></app-code-combo-box>
    </div>

    <label class="list-input-title">料理名</label>
    <div class="list-input-content">
      <app-text-input id="txi_CookingName" #txi_CookingName [subid]="'txi_CookingName'"
        [forcedEnabledMode]="'true'" [restrict]="'[ -￮]'" [maxChars]="20" [fullOnly]="true" [displayCountField]="false"
        [(ngModel)]="cookingName" [disabled]="txiCookingNameDisabled" [tabindex]="0" style="width:20rem;">
      </app-text-input>
    </div>

    <label class="list-input-title">材料名</label>
    <div class="list-input-content">
      <app-text-input id="txi_MaterialName" #txi_MaterialName [subid]="'txi_MaterialName'"
        [forcedEnabledMode]="'true'"[restrict]="'[ -￮]'" [maxChars]="20" [fullOnly]="true" [displayCountField]="false"
        [(ngModel)]="materialName" [disabled]="txiMaterialNameDisabled" [tabindex]="0" style="width:20rem;">
      </app-text-input>
    </div>

    <label class="list-input-title">キーワード</label>
    <div class="list-input-content">
      <app-text-area [restrict]="'[ -￮]'"  [displayCountField]="false"
        [fullOnly]="true" id="txi_KeyWord" #txi_KeyWord [subid]="'txi_KeyWord'" [maxChars]="128"
        [forcedEnabledMode]="'true'" [(ngModel)]="keyWord" [disabled]="txiKeyWordDisabled" [tabindex]="0" >
      </app-text-area>
    </div>

    <label class="list-input-title">催事・季節</label>
    <div class="list-input-content">
      <app-code-combo-box id="cmb_EventId" [subid]="'cmb_EventId'" [codeDiv]="'ct370'"
        [forcedEnabledMode]="'true'" [labelField]="'codeValueName'" #cmb_EventId
        [(ngModel)]="eventId" [disabled]="cmbEventIdDisabled" [tabindex]="0">
      </app-code-combo-box>
    </div>

    <label class="list-input-title">撮影内容区分</label>
    <div class="list-input-content">
      <app-code-combo-box id="cmb_PhotoContentsDiv" [subid]="'cmb_PhotoContentsDiv'" [codeDiv]="'ct372'"
        [forcedEnabledMode]="'true'" [labelField]="'codeValueName'" #cmb_PhotoContentsDiv
        [(ngModel)]="photoContentsDiv" [disabled]="cmbPhotoContentsDivDisabled" [tabindex]="0" >
      </app-code-combo-box>
    </div>

    <label class="list-input-title">撮影指示内容</label>
    <div class="list-input-content">
      <app-text-area [restrict]="'[ -￮]'" [displayCountField]="false"
        [fullOnly]="true" id="txi_PhotoInstructContents" #txi_PhotoInstructContents [subid]="'txi_PhotoInstructContents'" [maxChars]="128" [forcedEnabledMode]="'true'"
        [(ngModel)]="photoInstructContents" [disabled]="txiPhotoInstructContentsDisabled" [tabindex]="0" >
      </app-text-area>
    </div>

    <label class="list-input-title">撮影予定日</label>
    <div class="list-input-content">
      <wj-input-date id="dfd_PhotoSchedule" #dfd_PhotoSchedule
        forcedEnabledMode="none" [(text)]="photoSchedule" [isRequired]="false" format="yyyy/MM/dd"
        [value]="null" [tabindex]="0">
      </wj-input-date>
    </div>

    <label class="list-input-title">撮影場所</label>
    <div class="list-input-content">
      <app-studio-master-combo-box id="cmb_PhotoStudioId" [subid]="'cmb_PhotoStudioId'" [forcedEnabledMode]="'true'"
        #cmb_PhotoStudioId [(ngModel)]="photoStudioId" [disabled]="cmbPhotoStudioIdDisabled" [tabindex]="0">
      </app-studio-master-combo-box>
    </div>

    <label class="list-input-title">作成指示日</label>
    <div class="list-input-content">
      <input type="text" class="date" id="lbl_ImageInstructDate" #lbl_ImageInstructDate value="{{ this.imageInstructDate }}" readonly>
    </div>

    <label class="list-input-title">画像ファイル登録日</label>
    <div class="list-input-content">
      <input type="text" class="date" id="lbl_FileRegistDate" #lbl_FileRegistDate value="{{ this.fileRegistDate }}" readonly>
    </div>

    <label class="list-input-title">画像キャプション</label>
    <div class="list-input-content">
      <app-text-input id="txi_Caption" #txi_Caption [subid]="'txi_Caption'" [maxChars]="50" [restrict]="'[ -￮]'" [displayCountField]="false"
        [fullOnly]="true" [forcedEnabledMode]="'true'"
        [disabled]="txiCaptionDisabled" [(ngModel)]="captiontext" [tabindex]="0" [style.width.rem]="52">
      </app-text-input>
    </div>
  </div>
</div>
